import { Row, Col } from 'react-bootstrap';
import { Button } from '@orbita-ui/core';

interface ReportFormActionsProps {
  /**
   * Función que se ejecuta al hacer clic en el botón "Limpiar".
   */
  onClear: () => void;
  /**
   * Estado de carga para deshabilitar los botones y mostrar el spinner.
   */
  isLoading: boolean;
  /**
   * Etiqueta para el botón de envío (opcional).
   */
  submitLabel?: string;
}

export const ReportFormActions = ({
                                    onClear,
                                    isLoading,
                                    submitLabel = 'Generar Reporte',
                                  }: ReportFormActionsProps) => {
  return (
    <Row className="mt-4">
      <Col className="d-flex justify-content-end gap-2">
        <Button type="button" variant="outline" color="destructive" onClick={onClear} disabled={isLoading}>
          Limpiar
        </Button>
        <Button type="submit" loading={isLoading} disabled={isLoading}>
          {submitLabel}
        </Button>
      </Col>
    </Row>
  );
};